import { useQuery } from '@tanstack/react-query';
import { FeedMatch } from 'src/financial/financial-data/feedMatch';

export const useFeedMatch = (clientId: string, assetId: string, enabled: boolean) =>
  useQuery<FeedMatch>({
    queryKey: ['clients', clientId, 'assets', assetId, 'feed-match'],
    enabled: enabled && !!clientId && !!assetId,
  });
